module.exports = __webpack_public_path__ + "img/kiki.c64f0255.png";